<template>
    <div class="container">
        <Breadcrumb :pages="breadcrumbPages" />

        <div v-if="!loadingItems && !listItems.length" class="row">
            <div class="col-md-12">
                <div class="page-error">
                    <h2>Não foram encontrados itens para o termo informado para pesquisa.</h2>
                    <a :href="`${$SiteUrl}`">Voltar à página inicial</a>
                </div>
            </div>
        </div>

        <div v-else style="margin-bottom: 35px;">
            <h3>{{ totalItems }} itens encontrados para "{{ clearUrl(searchQuery) }}"</h3>

            <Loader v-if="loadingItems" />

            <SimpleList :list="listItems" :origem="'busca'" v-else />
        </div>
    </div>
</template>

<script>
    import Breadcrumb from './partials/Breadcrumb.vue'
    import SimpleList from './partials/SimpleList.vue'
    import axios from 'axios';

    export default {
        name: 'SearchList',
        metaInfo() {
            const route = this.$route;
            const _self = this;
            const head = {
                title: `${route.params.search} - Aldo Componentes`,
                link: [
                    { rel: 'canonical', href: `${_self.$SiteUrl}/pesquisa/${_self.beautifyUrl(route.params.search)}` }
                ]
            };
            if (!_self.loadingItems && !_self.listItems.length) {
                head.meta = [{
                    name: 'robots',
                    content: 'noindex,nofollow',
                }];
            }
            return head;
        },
        data() {
            return {
                listItems: [],
                loadingItems: true
            }
        },
        components: {
            Breadcrumb,
            SimpleList
        },
        computed: {
            totalItems: function () {
                // Soma todas as quantidades totais para retornar o número de itens

                let sum = 0;

                this.listItems.forEach((element) => {
                    if (element.SegmentoIdPai == 0) {
                        sum += element.QtdeProdutos
                    }
                })

                const api = axios.create({
                    withCredentials: true
                });

                if (sum === 1) {
                    if (isNaN(this.$route.params.search.split("-")[0]) == false) {
                        api.post(this.$apiUrl + "Produto.svc/getprodutosdalista",
                            {
                                produtos: [
                                    this.$route.params.search.split("-")[0]
                                ]
                            }).then((response) => {
                                response.data.forEach((element) => {
                                    let product = {};
                                    product.code = element.PRD_CODIGO + "-" + element.PRD_CODIGODV;
                                    product.url = "/loja/produto/" + product.code + "/" + element.URL;
                                    location.href = product.url
                                })
                            })
                    }
                    else {
                        let last = this.listItems[this.listItems.length - 1].Slug;
                        api.post(this.$apiUrl + "Produto.svc/getprodutossegmentonome",
                            {
                                slug: last
                            }).then((response) => {
                                response.data.forEach((element) => {
                                    let product = {};
                                    product.code = element.PRD_CODIGO + "-" + element.PRD_CODIGODV;
                                    product.url = "/loja/produto/" + product.code + "/" + element.URL;
                                    location.href = product.url
                                })
                            })
                    }
                }

                return sum;
            },
            breadcrumbPages: function () {
                return [
                    { name: "Home", link: "/loja" },
                    { name: this.clearUrl(this.searchQuery) }
                ];
            },
            searchQuery: function () {
                this.getItems();
                return this.$route.params.search;
            },
        },
        methods: {
            beautifyUrl: function (url) {
                url = url.split(" ").join('%');
                url = url.charAt(0) + url.slice(1);
                return url.toLowerCase();
            },
            clearUrl: function (url) {
                // Substitui os hífens por espaços
                url = url.replace(/-/g, ' ');

                return url;
            },
            getItems: function () {
                this.loadingItems = true;

                // Traz os resultados da busca
                var xhr = new XMLHttpRequest()

                xhr.onload = () => {
                    if (xhr.status == 200) {
                        this.loadingItems = false

                        let json = JSON.parse(xhr.responseText)
                        this.listItems = json
                    }
                }

                xhr.open("POST", this.$apiUrl + "Produto.svc/getsegmentosportermo")
                xhr.setRequestHeader("Content-type", "application/json")
                xhr.withCredentials = true
                xhr.send(JSON.stringify({
                    pTermo: this.$route.params.search,
                    origem: 'busca'
                }))
            }
        }
    }
</script>
